<template>
    <section class="hr-office-sign-in">
        <v-row no-gutters>
            <v-col class="hidden-sm-and-down" md="6">
                <v-img
                    :src="require('@/assets/hr-office/welcome.png')"
                    height="100%"
                    min-height="100vh"
                />
            </v-col>

            <v-col class="hr-office-sign-in__panel" cols="12" md="6">
                <div class="hr-office-sign-in__decorations hidden-sm-and-down" aria-hidden="true">
                    <v-img
                        :src="require('@/assets/hr-office/bubbles1.png')"
                        class="hr-office-sign-in__bubble-top"
                        contain
                        max-height="200"
                        width="100%"
                        position="top right"
                    />
                    <v-img
                        :src="require('@/assets/hr-office/bubbles2.png')"
                        class="hr-office-sign-in__bubble-bottom"
                        contain
                        max-height="200"
                        width="100%"
                        position="bottom left"
                    />
                </div>

                <v-row class="hr-office-sign-in__form" align="center" justify="center">
                    <v-col cols="10" md="6">
                        <v-container fluid>
                            <v-form @submit.prevent="$emit('submit')">
                                <v-card-text>
                                    <v-text-field
                                        :value="credentials.email"
                                        @input="$emit('update:email', $event)"
                                        :error-messages="errors.email"
                                        name="email"
                                        label="Почта"
                                        mask="email"
                                        type="text"
                                        color="#5B5C79"
                                        solo
                                        flat
                                    />
                                    <v-text-field
                                        :value="credentials.password"
                                        @input="$emit('update:password', $event)"
                                        :error-messages="errors.password"
                                        name="password"
                                        label="Пароль"
                                        type="password"
                                        color="#5B5C79"
                                        solo
                                        flat
                                    />
                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                            :disabled="wait"
                                            :class="[{'js-sign-in-wait': wait}]"
                                            type="submit"
                                            color="primary"
                                            rounded
                                            class="px-5"
                                        >Войти</v-btn>
                                    </v-card-actions>
                                </v-card-text>
                            </v-form>
                        </v-container>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </section>
</template>

<script>
export default {
    name: 'SignInHrOffice',
    props: {
        credentials: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
        wait: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.hr-office-sign-in__panel {
    position: relative;
    display: flex;
    min-height: 100vh;
    background-color: #5B5C79;
}

.hr-office-sign-in__decorations {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
}

.hr-office-sign-in__bubble-top {
    position: absolute;
    top: 0;
    transform: rotate(180deg) translateY(25%);
}

.hr-office-sign-in__bubble-bottom {
    position: absolute;
    bottom: 0;
    transform: rotate(180deg) translate(-200px, -15%);
}

.hr-office-sign-in__form {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 48px 0;
}

.hr-office-sign-in__form >>> .v-messages.error--text {
    color: #FFFFFF !important;
}

.hr-office-sign-in__form >>> .v-input--is-focused .v-input__slot {
    outline: 2px solid #1F2937;
    outline-offset: 2px;
}

.hr-office-sign-in__form >>> .v-btn:focus {
    outline: 2px solid #FFFFFF;
    outline-offset: 3px;
}
</style>
